// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2CSG3","overlayOpen":"App_overlayOpen__3RNA3","app":"App_app__2ziFi","sidebar":"App_sidebar__3IISB","content":"App_content__1Wt3K"};